module.exports = __webpack_public_path__ + "img/rever-isotype-all-white.9bff9a5a.svg";